export const DESKTOP_SUBMIT_FORM_URL =
  'https://static.cdn-cian.ru//frontend/e2e-form-assets/demand/splashscreens/firecracker.png';
